import { Module, Action, getModule, Mutation } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import ConclusionsFilter from './filterEntity';
import FilterModel from './filterModel';

import { Conclusions } from '@/models/conclusions';
import { processConclusionsList } from './backend';

export const MODULE_NAME = Conclusions.moduleName;

const filterModel = new FilterModel();
const filter = getModule(ConclusionsFilter);

filter.setFilterName('clinicsFilter');
filter.setTemplateClassName('template-lg');
filter.setFilterModel(filterModel.filterModel);
filter.setFilterHandlers(filterModel.filterHandlers);

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class ConclusionsModule extends PageBaseModule {
    filter = filter;
    id: string | null = null;

    constructor(module: ConclusionsModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Conclusions.listTitle);
        page.setTitleAdd(Conclusions.createTitle);
        page.values.actionPagination = 'conclusions/updatePage';
        page.values.actionPageAmountItems = 'conclusions/updatePageAmountItems';
        page.values.pageAmountItems = 50;

        this.pageSettings = page.values;
        this.pageSettings.routeName = 'patients_conclusions_edit';
        this.pageSettings.routeParam = `patientsId`;
        this.pageSettings.routeParamAdditional = `conclusionsId`;
    }

    @Mutation
    SET_ID(id: string | null) {
        this.id = id;
        this.pageSettings.routeParamValue = id || '';
    }

    @Action({ rawError: true })
    async setPatientId(patientId: string) {
        this.SET_ID(patientId);
        filter.SET_SEARCH({ key: 'patientId', value: patientId });
        filter.updateFilter();
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                Conclusions.moduleName,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.setList(processConclusionsList(result.table));
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }
}

export default getModule(ConclusionsModule);